export default __webpack_public_path__ + "static/media/pinterest.d574d67c.png";